<popsy-icon-tamam class="icon" [ngClass]="size" aria-hidden="true" />
